import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import {
  reset,
  setLoading,
  setUserGroups,
  INITIAL_USER_GROUPS
} from './actions';

const userGroupReducer = handleActions(
  {
    [setUserGroups.toString()]: (_, { payload: groups }) => groups,
    [reset.toString()]: () => INITIAL_USER_GROUPS
  },
  INITIAL_USER_GROUPS
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  userGroups: userGroupReducer,
  loading: loadingReducer
});
